import { Tooltip } from "components/Tooltip/Tooltip";
import { AnchorButton } from "components/Button/AnchorButton";
import { Button } from "components/Button/Button";

import { useUserCanHaveFreeTeam } from "./hooks/useUserCanHaveFreeTeam";

import type { Origin } from "./PricingCards";

const new_team: Origin = "new_team";

export function ButtonSubscribeFromNewTeam(props: {
  plan: { id: number; name: string };
  teamHandle: string;
}) {
  const { plan, teamHandle } = props;

  const userCanHaveFreeTeam = useUserCanHaveFreeTeam();

  const subscribeLink = `/t/${teamHandle}/subscribe/${plan.name}?origin=${new_team}`;
  const freeTeamSuccessLink = `/t/${teamHandle}/subscribe/success/new_team?as-team=${teamHandle}`;

  if (plan.id === 1) {
    return !userCanHaveFreeTeam ? (
      <Tooltip
        label="You can't own more than 3 teams on the free plan."
        position="below-center"
      >
        <Button size="M" theme="tertiary" disabled>
          Continue with free
        </Button>
      </Tooltip>
    ) : (
      <AnchorButton size="M" theme="tertiary" href={freeTeamSuccessLink}>
        Continue with free
      </AnchorButton>
    );
  }

  return (
    <AnchorButton size="M" theme="secondary" href={subscribeLink}>
      Subscribe
    </AnchorButton>
  );
}
